import { render } from "./SecondSliderMainArticle.vue?vue&type=template&id=e9c0d3be&scoped=true"
import script from "./SecondSliderMainArticle.vue?vue&type=script&lang=js"
export * from "./SecondSliderMainArticle.vue?vue&type=script&lang=js"

import "./SecondSliderMainArticle.vue?vue&type=style&index=0&id=e9c0d3be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c0d3be"]])

export default __exports__